const tableHeader = ['id', 'Contexto', 'IP', 'Rota de Acesso', 'Usuário', 'Status', 'Data'];

export const table = {
  header: tableHeader,
  type: 'log',
};
